import { RegularButton } from "@components/buttons"
import { LoginModal } from "@components/modal"
import { container, Container, FlexBox } from "@components/wrapper"
import { useUserData } from "@lib/hooks/useUserData"
import clsx from "clsx"
import React, { useEffect, useState } from "react"
import { BootcampComponentProps } from "."
import ModalFileRequest from "../general/ModalFileRequest"

interface NavInfo {
  link: string
  label: string
}

export const BootcampNavigator = ({ schoolDetail }: BootcampComponentProps) => {
  const [linkActive, setLinkActive] = useState("")
  const [navigationLinks, setNavigationLinks] = useState<NavInfo[]>([])
  const [requestOpen, setRequestOpen] = useState(false)
  const [loginModal, setLoginModal] = useState(false)

  const { isLogin, tokenData } = useUserData()

  const NAVIGATION_LIST = [
    {
      label: "Overview & Benefit",
      link: "overview",
      detail: "",
      id: "btn-overview",
    },
    {
      label: "Kurikulum",
      link: "curriculum",
      detail: "school_courses",
      id: "btn-curriculum",
    },
    {
      label: "Metode Belajar",
      link: "methods",
      detail: "school_learning_experiences_images",
      id: "btn-methods",
    },
    {
      label: "Testimoni",
      link: "testimonials",
      detail: "school_testimonies",
      id: "btn-testimonials",
    },
    {
      label: "Perbandingan",
      link: "comparisons",
      detail: "",
      id: "btn-comparison",
    },
    {
      label: "Jadwal",
      link: "schedule",
      detail: "school_batch",
      id: "btn-schedule",
    },
    {
      label: "Kategori & Biaya",
      link: "fee",
      detail: "school_program_type",
      id: "btn-fee",
    },
  ]

  useEffect(() => {
    if (schoolDetail) {
      const links: NavInfo[] = []

      NAVIGATION_LIST.forEach((value) => {
        if (value.id === "btn-overview") {
          links.push({
            label: value.label,
            link: value.link,
          })
        }

        if (value.id === "btn-outcomes") {
          links.push({
            label: value.label,
            link: value.link,
          })
        }

        if (value.id === "btn-method") {
          links.push({
            label: value.label,
            link: value.link,
          })
        }

        if (schoolDetail[value.detail] && schoolDetail[value.detail].length) {
          links.push({
            label: value.label,
            link: value.link,
          })
        }
      })

      setNavigationLinks(links)
    }
  }, [schoolDetail])

  useEffect(() => {
    let HTMLs: any[] = []

    if (navigationLinks.length) {
      HTMLs = navigationLinks.map((value) => {
        return document.getElementById(`${value.link}`)
      })

      window.addEventListener("scroll", trackScrolling(HTMLs), { passive: true })
    }

    return () => {
      window.removeEventListener("scroll", trackScrolling(HTMLs))
    }
  }, [navigationLinks])

  const trackScrolling = (elements: HTMLElement[]) => () => {
    if (!elements.length) {
      return
    }

    const eleLength = elements.length
    let index = 0

    const getAll = elements.map((value) => {
      return {
        height: value?.getBoundingClientRect()?.height,
        top: value?.getBoundingClientRect()?.top,
      }
    })

    while (index < eleLength) {
      if (getAll[index].top < 110) {
        setLinkActive(navigationLinks[index].link)
      }
      index++
    }
  }

  const executeScroll = (id: string) => () => {
    const ele = document.getElementById(id)

    if (!ele) {
      return
    }

    ele.scrollIntoView({ behavior: "smooth" })
  }

  const LinkButton = ({ label, link }: { label: string; link: string }) => {
    return (
      <div className="relative">
        <button
          onClick={executeScroll(link)}
          className={clsx(
            "py-[22px] cursor-pointer",
            linkActive === link && "font-bold text-new-blue",
            linkActive === link &&
              "after:bg-new-blue after:h-[1px] after:absolute after:bottom-0 after:w-full after:left-0",
            linkActive !== link && "font-medium text-secondary-grey"
          )}
        >
          {label}
        </button>
      </div>
    )
  }

  function handleOpenPopup() {
    if (!isLogin) {
      setLoginModal(true)
    } else {
      setRequestOpen(true)
    }
  }

  return (
    <>
      {/* Web */}
      <div className="sticky top-[70px] sm-only:hidden bg-white z-[100]">
        <Container>
          <div className="flex justify-between items-end border-b border-new-grey">
            <FlexBox className="gap-4 relative">
              {navigationLinks.map((nav) => (
                <LinkButton label={nav.label} link={nav.link} key={nav.label} />
              ))}
            </FlexBox>

            <FlexBox className="pb-3 gap-4">
              <RegularButton
                variant="transparent-blue"
                className="!rounded-lg"
                onClick={handleOpenPopup}
              >
                Download Kurikulum
              </RegularButton>
              <RegularButton
                variant="new-blue"
                className="!rounded-lg"
                onClick={executeScroll("fee")}
              >
                Daftar
              </RegularButton>
            </FlexBox>
          </div>
        </Container>
      </div>

      {/* Mobile */}
      <FlexBox
        className={clsx(
          "sm:hidden fixed bottom-0 z-10 bg-white ",
          "w-full border-t border-new-grey py-3 gap-4",
          container
        )}
      >
        <RegularButton variant="transparent-blue" className="!rounded-lg" onClick={handleOpenPopup}>
          Download Kurikulum
        </RegularButton>
        <RegularButton
          variant="new-blue"
          className="!rounded-lg flex flex-1"
          onClick={executeScroll("fee")}
        >
          Daftar
        </RegularButton>
      </FlexBox>

      <ModalFileRequest
        data={tokenData}
        schoolId={schoolDetail?.product_id}
        mode="syllabus"
        show={requestOpen}
        onHide={() => setRequestOpen(false)}
      />
      <LoginModal show={loginModal} onHide={() => setLoginModal(false)} />
    </>
  )
}
